import type {Object3D} from 'three';

/**
 * 判断场景对象是否拥有其 geometry 的释放权。
 *
 * 设计说明：
 * 1. 大多数 Mesh、Line 等对象在构造时创建独立 geometry，可以随对象生命周期释放；
 * 2. THREE.Sprite 的 geometry 由 Three.js 模块内部全局共享，任意 Sprite 都不拥有其释放权；
 * 3. 使用 Three.js 稳定的 `isSprite` 运行时标记，避免不同导入入口或打包边界导致 `instanceof` 判断失效。
 *
 * @param object 待判断的场景对象。
 * @returns 当前对象可以释放自身 geometry 时返回 true。
 */
export function ownsObject3DGeometry(object: Object3D): boolean {
    return Reflect.get(object, 'isSprite') !== true;
}
